export default {
	setData(state, payload) {
		state.SupNoDownList = payload;
	},
	setTotalPage(state, payload) {
		state.Total = payload;
	},
	setIsLoading(state, payload) {
		state.IsLoading = payload;
	}
};
